import React, { useState } from "react";
import { MdWarning } from "react-icons/md";
import "./ClarificationDialog.css";

const ClarificationDialog = ({ isOpen, onSubmit, detectedIssue }) => {
  const [clarification, setClarification] = useState("");

  if (!isOpen || !detectedIssue) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clarification.trim()) {
      onSubmit(clarification);
      setClarification("");
    }
  };

  const getIssueMessage = () => {
    if (detectedIssue.type === "multiple_faces") {
      return "Multiple faces detected in the frame";
    }
    if (detectedIssue.type === "prohibited_objects") {
      return `Prohibited item detected: ${detectedIssue.details.detectedObjects.join(
        ", "
      )}`;
    }
    return "Suspicious activity detected";
  };

  return (
    <div className="clarification-dialog-overlay">
      <div className="clarification-dialog">
        <div className="clarification-content">
          <div className="clarification-icon">
            <MdWarning />
          </div>
          <h3>Action Required</h3>
          <div className="issue-description">
            <p>{getIssueMessage()}</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="clarification-input">
              <label htmlFor="clarification">
                Please provide clarification:
              </label>
              <textarea
                id="clarification"
                value={clarification}
                onChange={(e) => setClarification(e.target.value)}
                placeholder="Explain why this was detected..."
                rows={4}
                required
              />
            </div>
            <div className="clarification-actions">
              <button
                type="submit"
                className="submit-btn"
                disabled={!clarification.trim()}
              >
                Submit & Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ClarificationDialog;
